export default "__VITE_ASSET__BpJqzvV8__"